function Feature(data) {
    let feature = data || {};
    this.isActive = feature.isActive;
    this.activateDisplayDocuments = feature.activateDisplayDocuments;
    this.activateFavoriteAgents = feature.activateFavoriteAgents;
    this.favoriteAgents = feature.favoriteAgents;
}
module.exports = Feature;